import { createModalStore } from '@braskai/utils';

export const useBuyMinutesModalStore = createModalStore();
